export default "__VITE_ASSET__CeXCBZCr__"